import type {
  CreateMfaToken,
  PasskeyAuthRequest,
} from '@dynamic-labs/sdk-api-core';
import type { AuthenticationResponseJSON } from '@simplewebauthn/browser';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';

type ServerSigninPasskeyParams = {
  authentication: AuthenticationResponseJSON;
  createMfaToken?: CreateMfaToken;
};

export const serverSigninPasskey = async (
  { authentication, createMfaToken }: ServerSigninPasskeyParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const response = await apiClient.signinWithPasskey({
    environmentId: core.environmentId,
    passkeyAuthRequest: {
      ...authentication,
      createMfaToken,
      response: {
        ...authentication.response,
        clientDataJson: authentication.response.clientDataJSON,
      },
    } as PasskeyAuthRequest,
  });

  return response;
};
